import {Tooltip} from "bootstrap";

import 'jquery-toast-plugin/dist/jquery.toast.min.css'
import 'jquery-toast-plugin/dist/jquery.toast.min.js'

$(document).ready(function (){
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
})


require('./websockets');
